document.addEventListener("DOMContentLoaded", function () {
  // Footer accordion functionality for mobile
  const footerColumns = document.querySelectorAll(".footer__link-column");

  footerColumns.forEach((column) => {
    const title = column.querySelector(".footer__column-title");
    const content = column.querySelector(
      ".footer__link-list, .footer__menu-list, .footer__text-content"
    );

    if (title && content) {
      // Add keyboard support
      title.setAttribute("tabindex", "0");
      title.setAttribute("role", "button");
      title.setAttribute("aria-expanded", "false");

      const handleToggle = function (event) {
        event.preventDefault();

        // Close all other columns with smooth transition
        footerColumns.forEach((otherColumn) => {
          if (otherColumn !== column) {
            otherColumn.classList.remove("active");
            const otherTitle = otherColumn.querySelector(
              ".footer__column-title"
            );
            if (otherTitle) {
              otherTitle.setAttribute("aria-expanded", "false");
            }
          }
        });

        // Toggle current column with slight delay for smoother animation
        const isActive = column.classList.contains("active");

        if (!isActive) {
          // Opening - add small delay for visual feedback
          setTimeout(() => {
            column.classList.add("active");
            title.setAttribute("aria-expanded", "true");
          }, 50);
        } else {
          // Closing - immediate
          column.classList.remove("active");
          title.setAttribute("aria-expanded", "false");
        }
      };

      // Click event
      title.addEventListener("click", handleToggle);

      // Keyboard event
      title.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          handleToggle(event);
        }
      });

      // Touch event for better mobile experience
      title.addEventListener(
        "touchstart",
        function (event) {
          event.preventDefault();
          handleToggle(event);
        },
        { passive: false }
      );
    }
  });

  // Close accordion when clicking outside
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".footer__link-column")) {
      footerColumns.forEach((column) => {
        column.classList.remove("active");
        const title = column.querySelector(".footer__column-title");
        if (title) {
          title.setAttribute("aria-expanded", "false");
        }
      });
    }
  });

  // Handle window resize to reset accordion on desktop
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth > 749) {
        footerColumns.forEach((column) => {
          column.classList.remove("active");
          const title = column.querySelector(".footer__column-title");
          if (title) {
            title.setAttribute("aria-expanded", "false");
          }
        });
      }
    }, 250);
  });
});
